import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { SubscriptionsPageComponent } from './subscriptions.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: SubscriptionsPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class SubscriptionsPageRoutingModule {}
